/** Visible-card cap per turn on the STANDALONE surface — designer rule (monolith
 *  index.html :2477): the landing keeps a 3-card teaser (+ bottom fade). The
 *  PORTAL surface renders ALL cards the server sent (QA #19: "Found 5" header
 *  with only 3 cards visible — nothing is hidden in the portal). */
export const MAX_CARDS_PER_TURN = 3;

/** Per-surface visible-card cap. Shared so the turn renderer (<emma-chat-turn>)
 *  and the dialog-carry selection lookup (transcript-carry.findSelectedCardId)
 *  index the SAME card-id space: `tXcY` is built from the SLICED (visible) card
 *  index, not the absolute results index, so a lookup must apply the same cap
 *  for the same surface or it resolves to a card that was never rendered.
 *  Portal = Infinity (no cap, no fade); anything else = the standalone teaser. */
export function maxCardsForSurface(surface: string): number {
  return surface === 'portal' ? Number.POSITIVE_INFINITY : MAX_CARDS_PER_TURN;
}
